import { StockItem } from '../../../common/types/StockItemTypes';

/**
 * Path to the AI Toolkit video editor, which is served by Storyblocks Shell.
 * Mirrors AiToolsConstants::AI_VIDEO_EDIT_ROUTE.
 */
export const AI_VIDEO_EDIT_PATH = '/ai/video-edit';

/**
 * Build the deep link that drops the user into the shell video editor with this stock item selected.
 */
export function buildAiVideoEditUrl(stockItem: StockItem): string {
  const params = new URLSearchParams({
    contentId: String(stockItem.contentId),
  });

  return `${AI_VIDEO_EDIT_PATH}?${params.toString()}`;
}

/**
 * Open the shell video editor in a new tab with this stock item already selected.
 */
export function openAiVideoEditor(stockItem: StockItem): void {
  window.open(buildAiVideoEditUrl(stockItem), '_blank');
}
